import { createContext, useContext, useState } from 'react';

const SuperAdminHeaderContext = createContext({ slot: null, setSlot: () => {} });

export function SuperAdminHeaderProvider({ children }) {
    const [slot, setSlot] = useState(null);
    return (
        <SuperAdminHeaderContext.Provider value={{ slot, setSlot }}>
            {children}
        </SuperAdminHeaderContext.Provider>
    );
}

export const useHeaderSlot = () => useContext(SuperAdminHeaderContext);
